import {Component} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {MatDialogRef} from "@angular/material/dialog";
import {MaintenanceComponent} from "../maintenance/maintenance.component";
import {TooManyRequestOptions} from "./options/too-many-request.options";

@Component({
  selector: 'app-too-many-request',
  standalone: false,
  templateUrl: './too-many-request.component.html',
  styleUrls: ['./too-many-request.component.scss']
})
export class TooManyRequestComponent {
  public static URL?: string;
  tooManyRequestOptions = new TooManyRequestOptions();

  constructor(private http: HttpClient, private matDialogRef: MatDialogRef<MaintenanceComponent>) {
    this.matDialogRef.disableClose = true;
    let interval: any = setInterval(() => {
      http.get(TooManyRequestComponent.URL!.split('/api/')[0] + '/ready-health', {observe: 'events'}).subscribe((response) => {
        if (response instanceof HttpResponse) {
          clearInterval(interval);
          window.location.reload();
          this.tooManyRequestOptions.onResolved();
          matDialogRef.close();
        }
      });
    }, 5 * 1000);
  }
}
